"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GameServiceCache = exports.METHODS = exports.GameServiceError = exports.GameServiceResponse = exports.GameServiceRequest = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require("./utils");

var _PRIZE_TYPES = require("./PRIZE_TYPES");

var _PRIZE_TYPES2 = _interopRequireDefault(_PRIZE_TYPES);

var _eventsjs = require("@pch/eventsjs");

var _eventsjs2 = _interopRequireDefault(_eventsjs);

var _es6TemplateStrings = require("es6-template-strings");

var _es6TemplateStrings2 = _interopRequireDefault(_es6TemplateStrings);

var _ajax = require("./ajax");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BASE_URL_MEMBER = Symbol("baseUrl");
var AJAX_MEMBER = Symbol("ajax");
var REQ_TPL_MEMBER = Symbol("requestBodyTpl");
var DEFAULT_TO_MEMEBER = Symbol("defaultTimeout");
var DEFAULT_METHOD_MEMBER = Symbol("defaultMethod");
var DEFAULT_HEADERS_MEMBER = Symbol("defaultHeaders");

var REQ_TPL_DEFAULT = "default";

var METHOD_POST = "post";
var METHOD_GET = "get";
/**
* @namespace GameService.METHODS
*/
var METHODS = {
    /** 
    * @memberof GameService.METHODS
    * @constant {string} 
    **/
    POST: METHOD_POST,
    /** 
    * @memberof GameService.METHODS
    * @constant {string} 
    **/
    GET: METHOD_GET
};

/**
* @class
* @classdesc 
* The GameService handles all communication with the server/api. 
*
* Requests are made with GameServiceRequest instances for each api endpoint, and return GameServiceResponse or GameServiceError responses.  
*
* The service is configured with a base url, and can also be mocked by injecting the ajax module the service uses to make requests.  
*
* The service also implements the same pub/sub functionality as the GameManager, and fires the gameService.EVENTS.REQUEST_CALLBACK event for each request that is made.
*
* You receive the GameServiceRequest, GameServiceError, GameServiceResponse args.  
*
* You do not need to instantiate this on your own, GameManager will do so for you. Only do so if you need to override it's behaviour for your own purposes.
*
* @mixes external:EventsMixin
*
* @example 
*   var gm = new GameManager(gameJson);
*   // mock the service 
*   gm.service.ajax = mockAjaxModule; // implements the {module:ajax~AjaxInterface} api 
*   // receive callback for each request that is made 
*   gm.service.addEventListener(gm.service.EVENTS.REQUEST_CALLBACK, (req, err, resp) => { 
*       // req is instance of {GameServiceRequest} for the request that was made
*       // err is instance of {GameServiceError} if the response was an error response
*       // resp is instance of {GameServiceResponse} if the response was not an error response
*   });
*   // a shorthand is available on the GameManager for listening for only certain "event" requests
*   gm.addRequestEventListener("complete", (err, resp) => {
*       // request wade made with params.event === "complete"
*   });
*/

var GameService = function () {
    _createClass(GameService, null, [{
        key: "buildServiceUri",


        /**
        * parses the tokenized service uri given, and replaces with the matching properties
        *
        * The local variables available to the template are defined by {@link GameService~RequestBodyTemplateContext}
        *
        * @param {string} template - The tokenized url, tokens should be in the form {propertyName}
        * @param {object} properties - The tokens to replace into the url
        * @param {GameModel} gameModel - the game model instance to include as part of variables available to be interpolated
        *
        * @example buildServiceUri("http://pch.com/foo/api/{event}/{gmt}", {event:"bar", gmt: "abcdef"})
        *
        * @see {@link GameService~RequestBodyTemplateContext}
        *
        * @returns {string} The template url with the property values replaced
        */
        value: function buildServiceUri(template, properties, gameModel) {
            if (!template) {
                return template;
            }
            var serviceUri = GameService.templatizeString(template, "encodeURIComponent(", ")");
            return GameService.interpolateTemplate(serviceUri, properties, gameModel);
        }
    }, {
        key: "templatizeString",
        value: function templatizeString(str) {
            var wrapStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            var wrapEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

            return (str || "").replace(/([^\$])\{([\w\.]+)\}/g, "$1\${" + wrapStart + "$2" + wrapEnd + "}");
        }
    }, {
        key: "interpolateTemplate",
        value: function interpolateTemplate(tpl, params, gameModel) {
            // build up the locals to be available for the template
            var tplParams = (0, _utils.objectAssign)({}, gameModel || {});
            tplParams = (0, _utils.objectAssign)(tplParams, params);
            // alias security token
            var token = gameModel ? gameModel.getSecurityToken() : "";
            var securityToken = token || tplParams.security_token || tplParams.securitytoken || tplParams.securityToken;
            var jToken = token || tplParams.jtoken || tplParams.jToken;
            tplParams.security_token = tplParams.security_token || securityToken || jToken;
            tplParams.securitytoken = tplParams.securitytoken || securityToken || jToken;
            tplParams.securityToken = tplParams.securityToken || securityToken || jToken;
            tplParams.jtoken = tplParams.jtoken || jToken || securityToken;
            tplParams.jToken = tplParams.jToken || jToken || securityToken;
            // more aliases
            tplParams.appCode = tplParams.appCode || (gameModel ? gameModel.getAppCode() : "");
            tplParams.device = tplParams.device || (gameModel ? gameModel.getDevice() : "desktop");
            tplParams.pathId = tplParams.pathId || (gameModel ? gameModel.getPathId() : "");
            tplParams.itemId = tplParams.itemId || (gameModel ? gameModel.getItemId() : "");
            tplParams.email = tplParams.email || (gameModel ? gameModel.getUserEmail() : "");
            tplParams.gmt = tplParams.gmt || (gameModel ? gameModel.getUserGmt() : "");
            // interpolate the template, and return as serialized body
            var json = (0, _es6TemplateStrings2.default)(tpl, tplParams).trim();
            if (json[0] && json[0].match(/[\{\(\[]/)) {
                return JSON.parse(json);
            }
            return json;
        }
    }, {
        key: "baseUrl",


        /**
        * set the url to post to as the default for all services
        * @member {string}
        */
        set: function set(url) {
            this[BASE_URL_MEMBER] = ("" + (url || "")).replace(/\/$/, '');
        },
        get: function get() {
            return this[BASE_URL_MEMBER];
        }

        /**
        * inject your own ajax function, defaults to jQuery.ajax if available, or packaged ajax module fallback
        * this is the default ajax for all services
        *
        * @member {module:ajax~AjaxInterface}
        * @default external:jQuery.ajax
        */

    }, {
        key: "ajax",
        set: function set(func) {
            this[AJAX_MEMBER] = func;
        },
        get: function get() {
            return this[AJAX_MEMBER] || (typeof $ !== "undefined" ? $ && $.ajax : null) || _ajax2.default;
        }
    }]);

    function GameService() {
        _classCallCheck(this, GameService);

        (0, _utils.objectAssign)(this, _eventsjs2.default);

        /** @member {GameServiceCache} **/
        this.cache = GameServiceCache;

        /** @member {object} **/
        this.EVENTS = {
            /**
            * hook into any request, the callback receives the err/response for the request
            * @event GameService#requestCallback
            */
            REQUEST_CALLBACK: "onRequestCallback"
        };
    }

    /**
    * Get/set the game model instance for the service, to 
    * make the game data available for passing as request params
    * @member {GameModel}
    */


    _createClass(GameService, [{
        key: "getFullResourceUrl",


        /**
        * Pass a request and returns a full api url
        *
        * @param {GameServiceRequest} req
        *
        * @returns {string}
        */
        value: function getFullResourceUrl(req) {
            return GameService.buildServiceUri(this.baseUrl, req.params, this.gameModel);
        }

        /**
        * Returns wether the service url is setup with a jsonp endpoint
        *
        * @returns {bool}
        */

    }, {
        key: "setRequestBodyTemplate",


        /**
        * Set a parameterized request body template, with param placeholders replaced
        * from user/game data
        *
        * The local variables available to the template are defined by {@link GameService~RequestBodyTemplateContext}
        *
        * @param {object|string} dataTemplate - The paramterized data, eg {"email": "{user.email}", "itemId": "{item.id}"}. Can also be a string, eg) '{"itemId": {item.id}}'
        * @param {string} [eventName] - If given, this template will be used only when the request "event" value matches the given event name
        *
        * @see {@link GameService~RequestBodyTemplateContext}
        *
        * @example
        *   // eg, if gameModel is...
        *   // gameManager.gameModel.user = {"email": "foo@pchmail.com", "gmt": "abcdedf"};
        *   // gameManager.gameModel.item = {"id": 123, "sweep": {"curr_step": 2}};
        *   // gameManager.gameModel.item_type = "SweepsGame";
        *   // gameManager.gameModel.security_token = "xwz";
        *   gameManager.setRequestBodyTemplate({"event": "{event}", "someGameParam": "{gameParam}", "item_id": "{item.id}", "gmt": "{user.gmt}", "eventData": "{item.sweep.curr_step}", "securityToken": "{item.security_token}"})
        *   // a request made with this, new GameServiceRequest("completeEvent", {someGameParam: "myGameParam"})
        *   // produces this request body...
        *   {"event": "completeEvent", "someGameParam": "myGameParam", "item_id": "123", "gmt": "abcdedf", "eventData": "2", "securityToken": "xwz"})
        *
        * @example 
        *   // For even more advanced templates, the setRequestBodyTemplate actually supports 
        *   // js template (@see http://es6-features.org/#StringInterpolation) style string interpolation, 
        *   // with full expressions inside, use ${} delimiters in your template string for this style: 
        *   gameManager.setRequestBodyTemplate('{"event":"${event}","gamedata":${JSON.stringify(gamedata)},"itemId":{item.id}}');
        */
        value: function setRequestBodyTemplate(dataTemplate) {
            var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : REQ_TPL_DEFAULT;

            this[REQ_TPL_MEMBER] = this[REQ_TPL_MEMBER] || {};
            var tpl = typeof dataTemplate === "string" ? dataTemplate : JSON.stringify(dataTemplate);
            this[REQ_TPL_MEMBER][eventName] = GameService.templatizeString(tpl);
        }

        /**
        * Return the request body template for the given event param value. All templates are returned as strings, 
        * no matter whether they were originally set as objects or strings
        *
        * @param {string} [eventName="default"]
        *
        * @returns {string}
        */

    }, {
        key: "getRequestBodyTemplate",
        value: function getRequestBodyTemplate() {
            var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : REQ_TPL_DEFAULT;

            return this[REQ_TPL_MEMBER] ? this[REQ_TPL_MEMBER][eventName] : undefined;
        }

        /**
        * Return a request body given a request, and any existing templates that have been set for the matching event param
        *
        * @param {GameServiceRequest} serviceRequest
        * @param {GameModel} gameModel
        * @param {bool} [serialized=true] - false for a json object be returned, true for a string. String will be in form depending on the request method, see {@link GameServiceRequest.getSerializedBody()}
        *
        * @returns {string|object}
        */

    }, {
        key: "getRequestBody",
        value: function getRequestBody(serviceRequest, gameModel) {
            var serialized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            // get by the specific event name
            var tpl = this.getRequestBodyTemplate(serviceRequest.eventParamVal);
            if (!tpl) {
                // fallback to default template
                tpl = this.getRequestBodyTemplate(REQ_TPL_DEFAULT);
                // no template set, just return the current request body
                if (!tpl) {
                    return serviceRequest.serializedBody;
                }
            }
            var json = GameService.interpolateTemplate(tpl, serviceRequest.params, gameModel);
            return serialized ? GameServiceRequest.getSerializedBody(serviceRequest, json) : json;
        }

        /**
        * Returns the timeout in ms for the given request
        *
        * @param {GameServiceRequest} serviceRequest
        *
        * @rerurns {int} timeout in ms
        */

    }, {
        key: "getRequestTimeout",
        value: function getRequestTimeout(serviceRequest) {
            return serviceRequest.timeout ? serviceRequest.timeout * 1000 : 5000;
        }

        /**
        * Make an api request
        *
        * @param {GameServiceRequest}
        * @param {GameService~requestCallback} callback - first arg will be GameServiceError if failed, or a GameServiceResponse as the second arg
        * @param {Class<GameServiceResponse>} [responseClass=GameServiceResponse] - The class to instantiate for the response, should extend GameServiceResponse
        * @param {object} [opts] - Additional options, these include
        *   @param {bool} [opts.cache] - True if the request should be cached for this session
        *   @param {string} [opts.cacheScope] - A scope key to distinguish this from identical requests (eg separated by user gmt)
        *
        * @fires GameService#requestCallback
        * @ignore
        */

    }, {
        key: "doRequest",
        value: function doRequest(serviceRequest, callback) {
            var _this = this;

            var responseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GameServiceResponse;
            var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            if (opts && opts.cache) {
                if (this.cache.doCachedRequest(serviceRequest, callback, responseClass, opts)) {
                    return;
                }
            }
            this.ajax((0, _utils.objectAssign)({
                type: serviceRequest.method,
                url: this.getFullResourceUrl(serviceRequest),
                headers: serviceRequest.headers,
                data: this.getRequestBody(serviceRequest, this.gameModel), //serviceRequest.serializedBody,
                timeout: this.getRequestTimeout(serviceRequest),
                //dataType: 'json',
                success: function success(data, statusCode, xhr) {
                    var resp = new responseClass(data, xhr.status);
                    // error response
                    if (GameServiceError.isErrorResponse(resp) || resp.isErrorResponse()) {
                        var err = GameServiceError.create(xhr);
                        callback(err);
                        _this.fireEvent(_this.EVENTS.REQUEST_CALLBACK, serviceRequest, err);
                    }
                    // success response
                    else {
                            if (opts && opts.cache) {
                                _this.cache.cacheResponse(serviceRequest, resp, opts);
                            }
                            callback(null, resp);
                            _this.fireEvent(_this.EVENTS.REQUEST_CALLBACK, serviceRequest, null, resp);
                        }
                },
                error: function error(xhr, errorType, _error) {
                    var err = GameServiceError.create(xhr);
                    callback(err);
                    _this.fireEvent(_this.EVENTS.REQUEST_CALLBACK, serviceRequest, err);
                }
            }, this.isJsonP ? { jsonp: "callback", dataType: "jsonp", jsonpCallback: "cors" } : {}));
        }

        /**
        * Make a "start" event service call
        *
        * @param {string} jToken
        * @param {string|number} gameId
        * @param {object} [gameData]
        * @param {object} [serviceData]
        * @param {GameService~requestCallback} callback
        *
        * @fires GameService#requestCallback
        */

    }, {
        key: "start",
        value: function start(jToken, gameId, gameData, serviceData, callback) {
            var req = new GameServiceRequest("start", {
                "jtoken": jToken,
                "gameid": gameId,
                "apidata": serviceData,
                "gamedata": gameData
            });
            return this.doRequest(req, callback);
        }

        /**
        * Make a "end" event service call
        *
        * @param {string} jToken
        * @param {string|number} gameId
        * @param {object} [gameData]
        * @param {object} [serviceData]
        * @param {GameService~requestCallback} callback
        *
        * @fires GameService#requestCallback
        */

    }, {
        key: "end",
        value: function end(jToken, gameId, gameData, serviceData, callback) {
            var req = new GameServiceRequest("end", {
                "jtoken": jToken,
                "gameid": gameId,
                "apidata": serviceData,
                "gamedata": gameData
            });
            return this.doRequest(req, callback);
        }

        /**
        * Make a "complete" event service call
        *
        * @param {string} jToken
        * @param {object} serviceData
        * @param {GameService~requestCallback} callback
        *
        * @fires GameService#requestCallback
        */

    }, {
        key: "complete",
        value: function complete(jToken, serviceData, callback) {
            var req = new GameServiceRequest("complete", {
                "jtoken": jToken,
                "apidata": serviceData
            });
            return this.doRequest(req, callback);
        }

        /**
        * Generic game event call
        *
        * @param {string} eventName - The event name
        * @param {object} [reqParams] - the other request params body
        * @param {GameService~requestCallback} callback
        *
        * @fires GameService#requestCallback
        */

    }, {
        key: "gameEvent",
        value: function gameEvent(eventName, reqParams, callback) {
            var req = new GameServiceRequest(eventName, reqParams);
            return this.doRequest(req, callback);
        }

        /**
        * Make a "getnextgame" request
        *
        * @param {string} jToken
        * @param {string|number} gameId
        * @param {GameService~requestCallback} callback
        *
        * @fires GameService#requestCallback
        */

    }, {
        key: "nextGame",
        value: function nextGame(jToken, gameId, callback) {
            var req = new GameServiceRequest("getnextgame", {
                "jtoken": jToken,
                "gameid": gameId
            });
            return this.doRequest(req, callback);
        }

        /**
        * Make a "forfeit" event service call
        *
        * @param {string} jToken
        * @param {GameService~requestCallback} callback
        */

    }, {
        key: "forfeit",
        value: function forfeit(jToken, callback) {
            var req = new GameServiceRequest("forfeit", {
                "jtoken": jToken
            });
            return this.doRequest(req, callback);
        }
    }, {
        key: "gameModel",
        set: function set(model) {
            this._gameModel = model;
        },
        get: function get() {
            return this._gameModel;
        }

        /**
        * set the service url for this service instance 
        *
        * @member {string}
        * @default GameService.baseUrl class member value
        */

    }, {
        key: "baseUrl",
        set: function set(url) {
            this[BASE_URL_MEMBER] = url;
        },
        get: function get() {
            return this[BASE_URL_MEMBER] || GameService.baseUrl;
        }

        /**
        * inject the ajax function for this service instance
        *
        * @member {module:ajax~AjaxInterface}
        * @default GameService.ajax class member value
        */

    }, {
        key: "ajax",
        set: function set(func) {
            this[AJAX_MEMBER] = func;
        },
        get: function get() {
            return this[AJAX_MEMBER] || GameService.ajax;
        }
    }, {
        key: "isJsonP",
        get: function get() {
            return this.baseUrl.match(/[&\?]callback\b/);
        }
    }]);

    return GameService;
}();

/**
* @class
* @classdesc
* Base class for requests. 
*
* @param {string} eventName - (eg "start")
* @param {object} params - the request params
* @param {string} methods - The request method, one of GameService.METHODS constants, pass METHOD_POST or METHOD_GET constants
* @param {object} [headers] - Additional request headers
*/


var GameServiceRequest = function () {
    function GameServiceRequest(eventName, params, method, headers) {
        _classCallCheck(this, GameServiceRequest);

        this.method = method || GameServiceRequest.defaultMethod;
        this.params = (0, _utils.objectAssign)({ event: eventName }, params || {});
        this.headers = (0, _utils.objectAssign)({}, GameServiceRequest.defaultHeaders);
        this.headers = (0, _utils.objectAssign)(this.headers, headers || {});
        /*
        this.headers = objectAssign({
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content'),
        }, headers || {});
        */
    }

    /**
    * Returns the serialized body for the given request
    *
    * @param {GameServiceRequest} request - The request, whose method which will determine the serialization
    * @param {object} [reqParams] - optionally override the params to serialize, instead of those attached to the request already
    *
    * @returns {string}
    */


    _createClass(GameServiceRequest, [{
        key: "timeout",


        /**
        * The timeout in seconds for this request
        * @member {int}
        * @default GameService.defaultTimeout
        */
        get: function get() {
            return this._timeout || GameServiceRequest.defaultTimeout;
        },
        set: function set(val) {
            this._timeout = val;
        }

        /**
        * Whether or not requests should be encoded as json bodies
        * @member {bool}
        * @default true
        */

    }, {
        key: "jsonPosts",
        get: function get() {
            return this._jsonPosts !== false;
        },
        set: function set(val) {
            this._jsonPosts = !!val;
        }

        /**
        * Returns the serialized request body
        * @member {string}
        * @readonly
        */

    }, {
        key: "serializedBody",
        get: function get() {
            return GameServiceRequest.getSerializedBody(this);
        }

        /**
        * Returns the request body encoded as query string
        * @member {string}
        * @readonly
        */

    }, {
        key: "queryStringifiedBody",
        get: function get() {
            return (0, _utils.queryStringify)(this.params);
            //return URL.qs.stringify(this.params);
        }

        /**
        * Returns the has key for this request
        * @member {string}
        * @readonly
        */

    }, {
        key: "hashKey",
        get: function get() {
            return this.method + "?" + this.queryStringifiedBody + '#' + (0, _utils.queryStringify)(this.headers);
        }

        /**
        * Get the "event" request parameter value if set
        *
        * @returns {string|undefined}
        * @readonly
        */

    }, {
        key: "eventParamVal",
        get: function get() {
            if (this.params) {
                return this.params.event;
            }
            return undefined;
        }
    }], [{
        key: "getSerializedBody",
        value: function getSerializedBody(request) {
            var reqParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            reqParams = reqParams ? reqParams : request.params;
            if (request.method == METHOD_POST) {
                return request.jsonPosts ? JSON.stringify(reqParams || {}) : (0, _utils.queryStringify)(reqParams);
            }
            return (0, _utils.queryStringify)(reqParams);
        }

        /**
        * The default timeout in seconds for all requests
        * @member {int}
        * @default undefined
        */

    }, {
        key: "defaultTimeout",
        get: function get() {
            return this[DEFAULT_TO_MEMEBER];
        },
        set: function set(val) {
            this[DEFAULT_TO_MEMEBER] = val;
        }

        /**
        * The default method for requests, one of GameService.METHODS constants
        * @member {string}
        * @default GameService.METHODS.POST
        */

    }, {
        key: "defaultMethod",
        get: function get() {
            return this[DEFAULT_METHOD_MEMBER] || METHOD_POST;
        },
        set: function set(val) {
            this[DEFAULT_METHOD_MEMBER] = val;
        }

        /**
        * The default headers for requests, will be merged with instance headers
        * @member {object}
        */

    }, {
        key: "defaultHeaders",
        get: function get() {
            return this[DEFAULT_HEADERS_MEMBER] || {};
        },
        set: function set(val) {
            this[DEFAULT_HEADERS_MEMBER] = val;
        }
    }]);

    return GameServiceRequest;
}();

/**
* @class
* @classdesc
* Base class for responses
* You can extend this for resource specific response functionality, and pass the class
* to the service doRequest() method to have it returned when the request completes
*
* @param {string|object} body - The response params
* @param {int} statusCode - The response http status code
*
*/


var GameServiceResponse = function () {
    function GameServiceResponse(body, statusCode) {
        _classCallCheck(this, GameServiceResponse);

        /** @member {string|object} **/
        this.body = body;
        /** @member **/
        this.responseText = body;
        if (typeof body === "string") {
            try {
                this.body = JSON.parse(body);
            } catch (e) {}
        }
        /** @member {int} */
        this.statusCode = statusCode;
    }

    /**
    * set to true when the response was returned from cache
    * @member
    */


    _createClass(GameServiceResponse, [{
        key: "isErrorResponse",


        /**
        * Returns whether or not this response represents an error
        *
        * @returns {bool}
        */
        value: function isErrorResponse() {
            return this.body && this.body.error && this.body.error.code > 0;
        }

        /**
        * Returns the iw_response data block from the response, if one exists
        * @member {object|null}
        * @readonly
        */

    }, {
        key: "isWinner",


        /**
        * Returns whether or not this response has wins data
        *
        * @returns {bool}
        */
        value: function isWinner() {
            var iwResponse = this.iwResponse;
            return iwResponse && iwResponse.wins && iwResponse.wins.length > 0;
        }

        /**
        * Returns whether or not this response has cash win data
        *
        * @returns {bool}
        */

    }, {
        key: "isCashWinner",
        value: function isCashWinner() {
            return this.getCashWins().length > 0;
        }

        /**
        * Returns whether or not this response has token win data
        *
        * @returns {bool}
        */

    }, {
        key: "isTokenWinner",
        value: function isTokenWinner() {
            return this.getTokenWins().length > 0;
        }

        /**
        * Return win data for the given PRIZE_TYPES type
        *
        * @param {string} type - one of the PRIZE_TYPES type constants to return matching win data for
        *
        * @returns {object[]}
        */

    }, {
        key: "getWinsByType",
        value: function getWinsByType(type) {
            var typeWins = [];
            var iwResponse = this.iwResponse;
            // skill game response
            if (!iwResponse && this.body.tokens && type == _PRIZE_TYPES2.default.TOKEN) {
                typeWins.push({
                    type: _PRIZE_TYPES2.default.TOKEN,
                    value: this.body.tokens
                });
            }
            // slots response
            else if (iwResponse && iwResponse.response && iwResponse.response.tokens && type == _PRIZE_TYPES2.default.TOKEN) {
                    typeWins.push({
                        type: _PRIZE_TYPES2.default.TOKEN,
                        value: parseInt(iwResponse.response.tokens, 10)
                    });
                }
                // iw response
                else {
                        var wins = iwResponse && iwResponse.wins || [];
                        wins.forEach(function (win) {
                            if (win.type === type) {
                                typeWins.push(win);
                            }
                        });
                    }
            return typeWins;
        }

        /**
        * Returns cash win data, if any
        *
        * @returns {object[]}
        */

    }, {
        key: "getCashWins",
        value: function getCashWins() {
            return this.getWinsByType(_PRIZE_TYPES2.default.CASH);
        }

        /**
        * Returns token win data, if any
        *
        * @returns {object[]}
        */

    }, {
        key: "getTokenWins",
        value: function getTokenWins() {
            return this.getWinsByType(_PRIZE_TYPES2.default.TOKEN);
        }
    }, {
        key: "isCachedResponse",
        get: function get() {
            return !!this._isCachedResponse;
        },
        set: function set(val) {
            this._isCachedResponse = !!val;
        }
    }, {
        key: "iwResponse",
        get: function get() {
            if (!this.body) {
                return null;
            }
            if (this.body.data && this.body.data.iw_response) {
                return this.body.data.iw_response;
            }
            return this.body.iw_response || null;
        }
    }]);

    return GameServiceResponse;
}();

/**
* @class
* @classdesc
* Base class for error responses
*
* @param {int} statusCode - The http status code
* @param {string} message - The message returned
* @param {object} body - The full response body
*/


var GameServiceError = function () {
    function GameServiceError(statusCode, message, body) {
        _classCallCheck(this, GameServiceError);

        /** @member {int} **/
        this.statusCode = statusCode;
        /** @member {string} **/
        this.message = message;
        /** @member {object} **/
        this.body = body;
    }

    /**
    * Returns the iw_response data block from the response, if one exists
    * @member {object|null}
    * @readonly
    */


    _createClass(GameServiceError, [{
        key: "iwResponse",
        get: function get() {
            if (!this.body) {
                return null;
            }
            if (this.body.data && this.body.data.iw_response) {
                return this.body.data.iw_response;
            }
            return this.body.iw_response || null;
        }

        /**
        * Returns whether or not the response represents an error
        *
        * @param {GameServiceResponse} resp
        *
        * @returns {bool}
        */

    }], [{
        key: "isErrorResponse",
        value: function isErrorResponse(resp) {
            return resp.body.status === "error" || resp.iwResponse && resp.iwResponse.error === true || resp.iwResponse && resp.iwResponse.type === "error";
        }

        /**
        * Factory method to create a default GameServiceError instance
        *
        * @returns {GameServiceError}
        */

    }, {
        key: "createDefault",
        value: function createDefault() {
            return new GameServiceError(0, "", { status: 0, iw_response: { type: "error", data: { code: 37, message: "Network Error" } }, "jToken": "" });
        }

        /**
        * Factory method to create a GameServiceError instance from a GameServiceResponse instance
        *
        * @param {GameServiceResponse}
        *
        * @returns {GameServiceError}
        */

    }, {
        key: "createFromResponse",
        value: function createFromResponse(resp) {
            return new GameServiceError(resp.statusCode, "", resp.body);
        }

        /**
        * Factory method to create a GameServiceError instance from an xhr object
        *
        * @param {xhr}
        *
        * @returns {GameServiceError}
        */

    }, {
        key: "create",
        value: function create(xhr) {
            var body = {};
            try {
                body = xhr.responseText ? JSON.parse(xhr.responseText) : {};
            } catch (e) {
                body.message = xhr.responseText;
            }
            if (!body.iw_response && (!body.data || !body.data.iw_response)) {
                var def = GameServiceError.createDefault();
                Object.assign(def.body, body.data || {});
                return def;
            }
            return new GameServiceError(xhr.status, body.message || "", body);
        }
    }]);

    return GameServiceError;
}();

/**
* Get cache key for a request
*
* @memberof GameServiceCache
* @static
*
* @param {GameServiceRequest}
* @param {object} [opts]
*   @param {string} [opts.cacheScope]
*
* @returns {string}
*/


function getCacheKey(serviceRequest, opts) {
    var cacheScope = opts && opts.cacheScope || "";
    var cacheKey = "lotto.gameServiceRequest." + (cacheScope ? cacheScope + "." : "") + serviceRequest.hashKey;
    return cacheKey;
}

/**
* Return storage interface
*
* @ignore
* @param {object} [opts]
*   @param {object} [opts.cacheStorage=sessionStorage]
*
* @returns {object}
*/
function getCacheStorage(opts) {
    return opts && opts.cacheStorage || sessionStorage;
}

/**
* Attempt to find cached response for the given request and handle the callback
*
* @memberof GameServiceCache
* @static
*
* @param {GameServiceRequest} serviceRequest - request instance
* @param {GameService~requestCallback} callback - The callback to accept the response if cached exists
* @param {Class<GameServiceResponse>} responseClass - the response class to instantiate from the cached response data
* @param {object} [opts] - Additional options, related params include
*   @param {string} [opts.cacheScope] - The scope to cache under to separate identical requests (eg for separate users, gmt)
*   @param {object} - [opts.cacheStorage] - The storage instance, defaults to native sessionStorage, but you can pass your own as long as it has the same interface
*
* @returns {bool} True if cached response was found and handled, False otherwise
*/
function doCachedRequest(serviceRequest, callback, responseClass, opts) {
    var cacheKey = getCacheKey(serviceRequest, opts);
    var storage = getCacheStorage(opts);
    try {
        var cached = storage.getItem(cacheKey);
        cached = cached ? JSON.parse(cached) : null;
        if (cached) {
            var resp = new responseClass(cached.body, cached.statusCode);
            resp.isCachedResponse = true;
            callback(null, resp);
            return true;
        }
    } catch (e) {
        console.log("ERROR", e);
    }
    return false;
}

/**
* Cache a response
*
* @memberof GameServiceCache
* @static
*
* @param GameServiceResponse
* @param object Additional options, related params include
*   cacheScope - string - The scope to cache under to separate identical requests (eg for separate users, gmt)
*   cacheStorage - object - The storage instance, defaults to native sessionStorage, but you can pass your own as long as it has the same interface
*/
function cacheResponse(serviceRequest, serviceResponse, opts) {
    var cacheKey = getCacheKey(serviceRequest, opts);
    var storage = getCacheStorage(opts);
    storage.setItem(cacheKey, JSON.stringify({ body: serviceResponse.body, statusCode: serviceResponse.statusCode }));
}

/**
* Callback to service requests
*
* @callback GameService~requestCallback
*
* @param {GameServiceError} [error] - first arg will be GameServiceError if failed, or null if not failed
* @param {GameServiceResponse} [resp] - service response
*/

/**
* The context of local variables available to request body templates set with {@link GameService#setRequestBodyTemplate}
* @typedef {object} GameService~RequestBodyTemplateContext
* @property {object} item - the "item" data block from the game json the manager was instantiated with
* @property {string|number} itemId
* @property {object} game - an alias to "item" or the 'game" data block from the game json the manager was instantiated with
* @property {object} user
* @property {string} security_token - the request security token (also available aliases as "securitytoken", "securityToken", "jtoken", "jToken")
* @property {string} event - the request "event" param
* @property {string|number} gameid - the item/game id
* @property {object} [gamedata] - any params the game posts in the event, this is only available to "start", "end" and the generic gameEvent() calls
* @property {string} [appCode]
* @property {string} [device]
* @property {string|number} [pathId]
* @property {string} [gmt] - user gmt
* @property {mixed} [*] - any other params sent in the game event from the game
*/

/**
* @class 
* @hideconstructor
*/
var GameServiceCache = {
    getCacheKey: getCacheKey,
    doCachedRequest: doCachedRequest,
    cacheResponse: cacheResponse
};

exports.GameServiceRequest = GameServiceRequest;
exports.GameServiceResponse = GameServiceResponse;
exports.GameServiceError = GameServiceError;
exports.METHODS = METHODS;
exports.GameServiceCache = GameServiceCache;
exports.default = GameService;